


























import { Component, Mixins } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "../../../../base/components/developer/mixins";
import { ModelEditableMixin, PdfStyleDrawableMixin } from "../../../../base/components/system/mixins";
import { PdfViewer } from "../../../../base/components/system/viewers";
import { Separator } from "../../../../base/components/system";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { UnsynchronizedFormatsSelector } from "../selectors";

@Component({
  components: {
    PdfViewer,
    Separator,
    UnsynchronizedFormatsSelector,
  }
})
export default class UnsynchronizedFormatListViewer extends Mixins(ModelEditableMixin, PdfStyleDrawableMixin, DeveloperPresentableMixin) {
  data() {
    return {
    };
  }
  selectorWidth: number = 1200;

  $refs!: {
    unsynchronizedFormatsSelector: UnsynchronizedFormatsSelector,
  };

  get isSingleFormatSelected(): boolean {
    return (this.editingSource !== null && this.editingSource.length === 1);
  }

  get selectedFormat(): EditableFormatSummary {
    return (!!this.editingSource && this.editingSource.length === 1) ? this.editingSource[0] : null;
  }

  get selectedPreviewSource(): string {
    return (!this.selectedFormat || !this.selectedFormat.previewSource)
      ? ""
      : this.selectedFormat.previewSource.source;
  }

  updateList(): void {
    this.$refs.unsynchronizedFormatsSelector.loadUnsynchronizedFormats();
  }
}
